import { render, staticRenderFns } from "./page06.vue?vue&type=template&id=5c9903bd&scoped=true&"
import script from "./page06.vue?vue&type=script&lang=js&"
export * from "./page06.vue?vue&type=script&lang=js&"
import style0 from "./page06.vue?vue&type=style&index=0&id=5c9903bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9903bd",
  null
  
)

export default component.exports